import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MiniFooter } from '@app/src/common/MiniFooter';
import { ButtonsAction } from '@app/src/common/ButtonsAction';
import {
  PriceConceptWrapper,
  ButtonPrevWrapper,
  ButtonNextWrapper,
  ButtonActionsWrapper,
  Wrapper
} from './styled';
import { isClientEnv } from '@app/src/utils/validations';
import { updatePriceTotal } from '@app/src/views/StepOne/form';
import { COLORS } from '@app/src/ui';

const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  handleButtonNext?: Function;
  handleButtonBack?: Function;
  disabledButtonNext?: boolean;
  textButtonBack?: string;
}

export const FormActions: React.FC<Props> = ({
  handleButtonNext,
  handleButtonBack,
  disabledButtonNext,
  textButtonBack
}) => {
  const dispatch = useDispatch();
  const printIsLoading = useSelector(state => state.print.isFetching);
  const [isFixedActionsButtons, setIsFixedActionsButtons] = useState(false);
  let active = false;
  const [isDisabledScroll, setIsDisabledScroll] = useState(false);
  const refWrapper = useRef(null);
  const refFooter = useRef(null);
  const priceTotalData = useSelector(state => state.priceTotal.data);
  const [price, setPrice] = useState(0);
  const print = isClient && JSON.parse(sessionStorage.getItem('print'));
  const typeUserAction = useSelector(state => state.session.user.pasarella);

  useEffect(() => {
    if (print && print.priceTotal && print.priceTotal.value && price === 0) {
      setPrice(print.priceTotal.value);
    }
  }, []);

  useEffect(() => {
    if (priceTotalData && Object.keys(priceTotalData).length > 0) {
      let currentPrice = 0;
      Object.keys(priceTotalData).map((id) => {
        currentPrice = currentPrice + priceTotalData[id].priceIgv;
      });
      setPrice(currentPrice);
    }
  }, [priceTotalData]);

  useEffect(() => {
    dispatch(updatePriceTotal(price));
  }, [price]);

  useEffect(() => {
    if (isClient) {
      if (window.innerWidth < BREAKPOINT) {
        window.addEventListener('scroll', handleScroll);
      }
      window.addEventListener('resize', handleResizeWindow);
      return () => {
        window.removeEventListener('resize', handleResizeWindow);
        if (window.innerWidth < BREAKPOINT) {
          window.removeEventListener('scroll', handleScroll);
        }
      }
    }
  }, []);

  const handleResizeWindow = useCallback(() => {
    if (window.innerWidth >= BREAKPOINT) {
      setIsFixedActionsButtons(false);
      window.removeEventListener('scroll', handleScroll)
    } else {
      window.addEventListener('scroll', handleScroll)
      if (active) {
        active = false;
      }
    }
  }, [dispatch]);

  const disabledScroll = () => {
    setIsDisabledScroll(false)
    setTimeout(() => {
      setIsDisabledScroll(true)
    }, 500)
  };

  const handleScroll = useCallback(() => {
    const bodyHeight = document.body.offsetHeight;
    const fixedElementHeight = refWrapper.current.offsetHeight;
    const footerHeight = refFooter.current.offsetHeight;

    if (!isDisabledScroll) {
      if (bodyHeight - (window.pageYOffset + window.innerHeight) > fixedElementHeight && active === false) {
        active = true;
        setIsFixedActionsButtons(true);
        disabledScroll();
      }
      if (bodyHeight - (window.pageYOffset + window.innerHeight) <= footerHeight && active === true) {
        active = false;
        setIsFixedActionsButtons(false)
        disabledScroll()
      }
    }
  }, [dispatch]);

  return (
    <Wrapper ref={refWrapper}>
      <ButtonActionsWrapper fixed={isFixedActionsButtons} >
        {
          typeUserAction === 'purchase-print' &&
          <PriceConceptWrapper
            isDisplay={isFixedActionsButtons}
            priceTotal={price} />
        }
        <ButtonsAction
          ButtonPrev={
            <ButtonPrevWrapper
              handleClick={handleButtonBack}
              background='#fff'
              color={COLORS.BLACK_BOLD}
              width={106}
              text={textButtonBack}
              icon={{ name: 'icon-back', color: COLORS.BLACK_BOLD, width: '16' }}
              left
            />
          }
          ButtonNext={
            <ButtonNextWrapper
              isDisplay={true}
              handleClick={handleButtonNext}
              background={COLORS.BLACK_BOLD}
              loading={printIsLoading}
              disabled={disabledButtonNext}
              color="#fff"
              text="Siguiente"
              width={140}
              icon={{ name: 'icon-back', color: '#fff', width: '16' }}
            />
          }
        />
      </ButtonActionsWrapper>
      <MiniFooter refFooter={refFooter} />
    </Wrapper>
  )
};
